import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatconfirmdialogComponent } from '../common/matconfirmdialog/matconfirmdialog.component';

export interface ComponentCanDeactivate {
  canDeactivate(): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PendingInvitationComponent
  implements CanDeactivate<ComponentCanDeactivate>
{
  constructor(private dialog: MatDialog) {}

  canDeactivate(
    component: ComponentCanDeactivate
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    // If `canDeactivate()` returns false, show confirmation dialog
    if (!component.canDeactivate()) {
   const dialogRef = this.dialog.open(MatconfirmdialogComponent, {
  width: '400px',
  data: {
    confirmmessage: 'Your request is in progress. Do you really want to leave this page?'
  }
});


      return dialogRef.afterClosed(); // returns Observable<boolean>
    }

    // If safe to leave, allow it
    return of(true);
  }
}
